import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import "roboto-fontface/css/roboto/roboto-fontface.css";
import "@fortawesome/fontawesome-free/css/all.css";
import toolbarMixin from "./mixins/toolbarMixin";

Vue.config.productionTip = false;

Vue.mixin(toolbarMixin);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
